//! Toggles nav's shadow
window.addEventListener("scroll", function() {
	const navWrapper = document.getElementById("nav-wrapper");
	
	if (this.scrollY > 46) {
		navWrapper.classList.add("shadow-md");
		navWrapper.classList.remove("shadow-none");
	}
	else {
		navWrapper.classList.remove("shadow-md");
		navWrapper.classList.add("shadow-none");
	}
});